export function NewsCardSkeleton() {
  return (
    <div className="flex gap-2.5 p-2.5 mb-2.5 rounded-xl bg-[#F7F7F7] dark:bg-gray-800 shadow-sm border border-gray-100 dark:border-gray-700 animate-pulse">
      <div className="w-[90px] h-[70px] shrink-0 rounded-lg bg-gray-200 dark:bg-gray-700"></div>
      <div className="flex flex-col flex-1 py-0.5 space-y-2">
        <div className="space-y-1.5">
          <div className="h-3 w-full bg-gray-200 dark:bg-gray-700 rounded-sm"></div>
          <div className="h-3 w-4/5 bg-gray-200 dark:bg-gray-700 rounded-sm"></div>
        </div>
        <div className="h-2 w-16 bg-gray-200 dark:bg-gray-700 rounded-sm mt-auto"></div>
      </div>
    </div>
  );
}

export function FeaturedRowSkeleton() {
  return (
    <div className="w-full mb-6 relative">
      <div className="w-full h-[320px] rounded bg-gray-200 dark:bg-gray-800 animate-pulse mb-4 shadow-sm"></div>
      <div className="flex gap-3 overflow-hidden px-1">
        <div className="w-[180px] md:w-[220px] shrink-0 flex flex-col h-full space-y-2">
           <div className="aspect-[16/9] w-full rounded bg-gray-200 dark:bg-gray-800 animate-pulse shadow-sm"></div>
           <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded-sm w-full animate-pulse mt-1"></div>
           <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded-sm w-4/5 animate-pulse"></div>
        </div>
        <div className="w-[180px] md:w-[220px] shrink-0 flex flex-col h-full space-y-2">
           <div className="aspect-[16/9] w-full rounded bg-gray-200 dark:bg-gray-800 animate-pulse shadow-sm"></div>
           <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded-sm w-full animate-pulse mt-1"></div>
           <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded-sm w-4/5 animate-pulse"></div>
        </div>
        <div className="w-[180px] md:w-[220px] shrink-0 flex flex-col h-full space-y-2 hidden md:flex">
           <div className="aspect-[16/9] w-full rounded bg-gray-200 dark:bg-gray-800 animate-pulse shadow-sm"></div>
           <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded-sm w-full animate-pulse mt-1"></div>
           <div className="h-4 bg-gray-200 dark:bg-gray-800 rounded-sm w-4/5 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
}

export function CategoriesSkeleton() {
  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar">
      {[1, 2, 3, 4, 5, 6, 7].map(i => (
        <div key={i} className="h-[32px] w-[72px] bg-gray-200 dark:bg-gray-800 rounded-full animate-pulse shrink-0"></div>
      ))}
    </div>
  );
}

export function HomeGridSkeleton() {
  return (
    <div className="w-full flex flex-col gap-6 animate-pulse">
      {/* Desktop Main Grid */}
      <div className="hidden md:flex w-full h-[460px] lg:h-[500px] gap-4">
        <div className="w-[250px] xl:w-[280px] h-full bg-gray-100 dark:bg-gray-800 rounded-lg lg:block hidden"></div>
        <div className="flex-1 h-full bg-gray-100 dark:bg-gray-800 rounded-lg"></div>
        <div className="w-[260px] lg:w-[280px] xl:w-[320px] h-full bg-gray-100 dark:bg-gray-800 rounded-lg md:block hidden"></div>
      </div>
      
      {/* Mobile Main Grid */}
      <div className="md:hidden flex flex-col gap-4">
        <div className="w-full aspect-video bg-gray-100 dark:bg-gray-800 rounded-lg"></div>
        <div className="flex gap-3 overflow-hidden">
          <div className="w-[180px] h-[120px] bg-gray-100 dark:bg-gray-800 rounded-lg shrink-0"></div>
          <div className="w-[180px] h-[120px] bg-gray-100 dark:bg-gray-800 rounded-lg shrink-0"></div>
        </div>
      </div>
    </div>
  );
}

export function CategoryGridSkeleton() {
  return (
    <div className="flex flex-col md:grid md:grid-cols-2 lg:grid-cols-3 gap-6 animate-pulse w-full">
      <div className="md:col-span-2 lg:col-span-3">
        <div className="w-full aspect-video md:aspect-[21/9] bg-gray-100 dark:bg-gray-800 rounded-xl"></div>
        <div className="mt-4 space-y-2">
          <div className="h-6 bg-gray-100 dark:bg-gray-800 rounded-lg w-3/4"></div>
          <div className="h-4 bg-gray-100 dark:bg-gray-800 rounded-lg w-full"></div>
          <div className="h-4 bg-gray-100 dark:bg-gray-800 rounded-lg w-5/6"></div>
        </div>
      </div>
      {[1, 2, 3, 4, 5, 6].map(i => (
        <div key={i} className="flex flex-col gap-3">
          <div className="w-full aspect-[16/9] bg-gray-100 dark:bg-gray-800 rounded-xl"></div>
          <div className="space-y-2">
            <div className="h-5 bg-gray-100 dark:bg-gray-800 rounded-lg w-full"></div>
            <div className="h-5 bg-gray-100 dark:bg-gray-800 rounded-lg w-4/5"></div>
          </div>
        </div>
      ))}
    </div>
  );
}
